import { render } from "./atributosDetalle.vue?vue&type=template&id=04bc1e62&scoped=true"
import script from "./atributosDetalle.vue?vue&type=script&lang=js"
export * from "./atributosDetalle.vue?vue&type=script&lang=js"

import "./atributosDetalle.vue?vue&type=style&index=0&id=04bc1e62&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bc1e62"]])

export default __exports__